import React from 'react';
import { offerCards, CHECKOUT_URL } from '../data/salesContent';
import { trackAddToCart } from '../utils/metaPixel';
import type { OfferCard } from '../data/salesContent';
export function OfferStack() {
  return <section id="oferta" className="bg-ink px-5 py-14 sm:px-8" data-id="element-74" data-mp="2pu3o354strrs">
      <div className="mx-auto max-w-6xl" data-id="element-75" data-mp="2kw248hzjtof9">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-gold sm:text-[38px]" data-id="element-76" data-mp="2kxdaqpkdpaa2">
          Todo lo que Obtienes Hoy por Solo $9.99 USD
        </h2>

        <div className="-mx-5 mt-9 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-3 md:mx-0 md:grid md:grid-cols-2 md:gap-5 md:overflow-visible md:px-0 md:pb-0" data-id="element-77" data-mp="1t5p0q9p2ozue">
          {offerCards.map(card => <Card key={card.id} card={card} data-id="element-78" data-mp="224j36gp34kfv" />)}
        </div>

        <div className="mx-auto mt-12 max-w-xl text-center" data-id="element-79" data-mp="1efhrmkkygt6d">
          <p className="text-[14px] font-bold uppercase tracking-wide text-white/45" data-id="element-80" data-mp="1edwx2uyn5a8i">
            Valor total{' '}
            <span className="text-[18px] line-through decoration-red-500/80 decoration-2" data-id="element-81" data-mp="14p3c1ujtxjjg">
              $248.00 USD
            </span>
          </p>
          <p className="mt-2 font-display text-[40px] font-bold leading-none text-gold sm:text-[56px]" data-id="element-82" data-mp="19mvf9kpxcs2y">
            $9.99 USD
          </p>
          <p className="mt-3 text-[12px] text-white/55" data-id="element-83" data-mp="1eh922yqitqw0">
            Pago único · Sin suscripciones · Acceso de por vida
          </p>

          <img src="https://cdn.magicpatterns.com/uploads/hEAsRBwbJEP6wk8hRBR4F3/Portada_Producto_2B_3_BONOS.png" alt="Manual de Autosanación Energética junto a los 3 bonos gratis: Planificador de Autocuidado 7x7, Numerología Cabalística y Calendario Lunar de Sanación" className="mt-8 w-full rounded-lg" data-id="element-84" data-mp="lqr4uechajqi" />

          <a href={CHECKOUT_URL} onClick={() => trackAddToCart()} className="shimmer relative mt-7 block overflow-hidden rounded-xl border-2 border-gold bg-emerald-deep px-6 py-4 text-[13px] font-black uppercase tracking-wide text-white transition-colors duration-200 ease-out hover:bg-[#215c39] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold sm:text-[15px]" data-id="element-85" data-mp="znw2pr21gcao">
            ✅ Sí, quiero todo esto por $9.99 USD — Acceso inmediato
          </a>
          <p className="mt-3 text-[12px] text-white/55" data-id="element-86" data-mp="g1r4cii3a2pt">
            🔒 Pago seguro · SUPER Bono de Numerología incluido hoy
          </p>
        </div>
      </div>
    </section>;
}
interface CardProps {
  card: OfferCard;
}
function Card({
  card
}: CardProps) {
  const isMain = card.badgeTone === 'main';
  const isSuper = card.badgeTone === 'super';
  return <article className={`flex min-w-[85%] snap-center flex-col rounded-2xl bg-[#1a1a1a] p-5 transition-[transform,box-shadow] duration-200 ease-smooth hover:-translate-y-1.5 hover:shadow-[0_18px_40px_-20px_rgba(201,168,76,0.5)] md:min-w-0 ${isMain ? 'border-2 border-gold' : 'border border-gold/45'} ${isSuper ? 'card-glow' : ''}`} data-id="element-87" data-mp="242kndzrd1mc">
      <div className="flex items-start gap-4" data-id="element-88" data-mp="1g9e3633mbpet">
        <img src={card.image} alt={`Portada de ${card.title}`} className="h-24 w-24 shrink-0 rounded-md border border-gold/30 object-cover" data-id="element-89" data-mp="1l0w3coxthlyq" />
        <div data-id="element-90" data-mp="177ekz7gvafaa">
          <span className={`inline-block rounded px-2 py-1 text-[10px] font-black uppercase tracking-wider ${isSuper ? 'badge-breathe bg-gold text-ink' : isMain ? 'bg-gold/20 text-gold' : 'bg-white/10 text-white/75'}`} data-id="element-91" data-mp="1c8lrl379x8fd">
            {card.badge}
          </span>
          <h3 className="mt-2 font-display text-[17px] font-bold leading-snug text-white sm:text-[19px]" data-id="element-92" data-mp="1q238shchm928">
            {card.title}
          </h3>
        </div>
      </div>

      <ul className="mt-4 space-y-2" data-id="element-93" data-mp="ek2a3uk2jvwt">
        {card.bullets.map(b => <li key={b} className="flex gap-2 text-[13px] leading-relaxed text-white/75" data-id="element-94" data-mp="jk6ptid5kmlz">
            <span aria-hidden="true" className="text-gold" data-id="element-95" data-mp="yu3eezbp7ogu">
              ✦
            </span>
            {b}
          </li>)}
      </ul>

      {card.note && <p className="mt-3 text-[12px] font-bold text-red-400" data-id="element-96" data-mp="u10g6dvz7qub">{card.note}</p>}

      <div className="mt-auto flex items-center justify-between gap-3 border-t border-white/10 pt-4" data-id="element-97" data-mp="pz5hlh5fjrk8">
        <span className="text-[14px] text-white/45 line-through" data-id="element-98" data-mp="l02dbyx9xpdb">{card.value}</span>
        <span className={`rounded-full px-3 py-1 text-[11px] font-black uppercase tracking-wide ${isSuper ? 'badge-breathe bg-gold text-ink' : 'bg-emerald-deep text-white'}`} data-id="element-99" data-mp="1hrmq6apjjl6y">
          {card.tag}
        </span>
      </div>
    </article>;
}